import { render, staticRenderFns } from "./child.vue?vue&type=template&id=6ca37968&scoped=true&"
import script from "./child.vue?vue&type=script&lang=ts&"
export * from "./child.vue?vue&type=script&lang=ts&"
import style0 from "./child.vue?vue&type=style&index=0&id=6ca37968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca37968",
  null
  
)

export default component.exports